export enum Kind {
  AirMicrobial = "airMicrobial",
  SurfaceMicrobial = "surfaceMicrobial",
  DustDensity = "dustDensity",
  Water = "water",
}
